import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToCalendarConnection,
  mapApiResourceToExternalCalendarEvent,
  type AuthorizationUrlApiResource,
  type CalendarConnection,
  type CalendarConnectionApiResource,
  type ExternalCalendarEvent,
  type ExternalCalendarEventApiResource,
} from './calendarSyncApi.types';

const CALENDAR_SYNC_PATH = '/me/calendar-sync';

export async function fetchCalendarConnection(): Promise<CalendarConnection> {
  const response = await httpClient.get<CalendarConnectionApiResource>(
    CALENDAR_SYNC_PATH + '/connection'
  );
  return mapApiResourceToCalendarConnection(response.data);
}

export async function fetchCalendarAuthorizationUrl(): Promise<string> {
  const response = await httpClient.get<AuthorizationUrlApiResource>(
    CALENDAR_SYNC_PATH + '/authorize-url'
  );
  return response.data.authorization_url;
}

export async function completeCalendarAuthorization(
  code: string,
  state: string
): Promise<CalendarConnection> {
  const response = await httpClient.post<CalendarConnectionApiResource>(
    CALENDAR_SYNC_PATH + '/callback',
    { code, state }
  );
  return mapApiResourceToCalendarConnection(response.data);
}

export async function fetchExternalCalendarEvents(
  fromIsoDate: string,
  toIsoDate: string
): Promise<ExternalCalendarEvent[]> {
  const response = await httpClient.get<ExternalCalendarEventApiResource[]>(
    CALENDAR_SYNC_PATH + '/external-events',
    { params: { from: fromIsoDate, to: toIsoDate } }
  );
  return response.data.map(mapApiResourceToExternalCalendarEvent);
}

export async function disconnectCalendar(): Promise<CalendarConnection> {
  const response = await httpClient.delete<CalendarConnectionApiResource>(
    CALENDAR_SYNC_PATH + '/connection'
  );
  return mapApiResourceToCalendarConnection(response.data);
}
